import { FunctionComponent, useEffect, useState } from "react";
import { Positions, Teams } from "../../types/Player";
import { WizardProps } from "./FormNav";
import FormStyles from "./styled";
import { RatingConfig } from "constants/ratings";
import ChooseType from "./Steps/ChooseType";
import ChooseTeam from "./Steps/ChooseTeam";
import ChoosePosition from "./Steps/ChoosePosition";

import Decks from "./Steps/Decks";
import ChooseTrainers from "./Steps/ChooseTrainers";
import ChooseConfig, { FilterConfig } from "./Steps/ChooseConfig";
import ITrainer from "types/Trainer";

export type StepProps = {
  onClick: (value: any) => any;
  type?: "batter" | "pitcher";
  team?: Teams | "any";
  position?: Positions | "any";
  trainers?: ITrainer[];
  config?: RatingConfig;
  filters?: FilterConfig;
  locked?: string[];
} & WizardProps;

const Form: FunctionComponent<{}> = () => {
  const [type, setType] = useState<"batter" | "pitcher">("pitcher");
  const [team, setTeam] = useState<Teams | "any">("any");
  const [position, setPosition] = useState<Positions | "any">("any");
  const [trainers, setTrainers] = useState<ITrainer[]>([]);
  const [ratingConfig, setRatingConfig] = useState<RatingConfig>({});
  const [filters, setFilters] = useState<FilterConfig>({});
  const [locked, setLocked] = useState<string[]>([]);

  useEffect(() => {
    setLocked([]);
    setTrainers([]);
  }, [type]);

  return (
    <FormStyles.Form isLazyMount>
      <ChooseType onClick={setType} type={type} />
      <ChooseTeam onClick={setTeam} team={team} />
      <ChoosePosition onClick={setPosition} type={type} position={position} />
      <ChooseTrainers
        onSelected={setTrainers}
        type={type}
        trainers={trainers}
        onLock={setLocked}
        onClick={() => null}
        locked={locked}
      />
      <ChooseConfig
        onClick={() => null}
        config={ratingConfig}
        onFilterChange={setFilters}
        onRatingChange={setRatingConfig}
      />
      <Decks onClick={() => null} {...{ type, team, position, trainers, config: ratingConfig, filters, locked }} />
    </FormStyles.Form>
  );
};

export default Form;
